import {ProductImage, ProductVideo} from '@/__generated__/__types__';
import {Product} from '@/_application/modules/products/model/product';

export const getEmbeddedYoutubeUrl = (item: ProductVideo) => {
    const videoFullUrl = item?.video_content?.video_url;
    if (!videoFullUrl) {
        return '';
    }

    let videoId = '';
    if (videoFullUrl.includes('watch')) {
        const videoUrlWithId = videoFullUrl?.split('&')[0];
        videoId = videoUrlWithId.split('v=')[1];
    } else if (videoFullUrl.includes('youtu.be')) {
        const urlWithoutQuery = videoFullUrl.split('?')[0];
        videoId = urlWithoutQuery.split('youtu.be/')[1];
    }

    return videoId ? `https://www.youtube.com/embed/${videoId}` : videoFullUrl;
};

export const isProductVideo = (item: ProductImage | ProductVideo) => {
    return item?.__typename === 'ProductVideo';
};

export const isProductImage = (item: ProductImage | ProductVideo) => {
    return item?.__typename === 'ProductImage';
};
export const getAltText = (item: ProductImage | ProductVideo, index: number, product?: Product): string => {
    const productName = product?.name ?? 'Sản phẩm';

    if (isProductVideo(item)) {
        return item?.label ? `${productName}${item.label}` : `${productName}video`;
    }

    if (item?.label) {
        return `${productName}${item.label}`;
    }

    const positionLabels = ['mặt trước', 'mặt trái', 'mặt phải', 'mặt sau', 'góc nghiêng'];
    const label = positionLabels[index] || `hình ${index + 1}`;
    return `${productName}${label}`;
};